import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import EfProductMultiSpec from '@elem/ui/ef-product-multi-spec';
import ProductNav from '../../common/ProductNav';
import { generalKey, productPageTheme, generalKeys } from '../../config/pageConfig';
// import { formatMultiSpecData } from 'elem/utils/formatMultiSpecData';
import { productDetailData } from '@/service';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale } = useRouter();
    // const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    // const [productDataA, setProductDataA] = useState<any>({});

    const [productPageData, setProductPageData] = useState<any>({
        productCatagory: null,
        productSeries: [],
        supportDataArr: [],
    });

    const formatMultiSpecData = (catagory: any, arr: any) => {
        // return;
        const flag = arr?.every((item: any) => item && item?.skuList && item?.skuList.length > 0);
        if (!flag) {
            return [];
        }

        const { specGroupList } = (catagory && catagory[0]) || [];
        const commonGroups: any = [];

        arr?.map((item: any, _: number) => {
            if (!item?.skuList || item?.skuList.length === 0) {
                return;
            }
            const skuItem = item?.skuList[0];
            console.log({ skuItem });
            const skuSpecObj = JSON.parse(
                typeof skuItem?.ownSpec === 'string' && skuItem?.ownSpec?.length > 0 ? skuItem?.ownSpec : JSON.stringify(skuItem?.ownSpec) || '{}',
            );
            // 三者共有的secGroups（至少有一个）
            specGroupList?.map((group: any) => {
                if (arr?.some((_: any) => skuSpecObj[group?.specGroupId]) && !commonGroups?.includes(group)) {
                    commonGroups.push(group);
                }
            });

            // 三者至少有一个specParams
            commonGroups?.map((group: any) => {
                group.specParamList = group?.specParamList?.filter((param: any) => {
                    const groupObjP = JSON.parse(
                        typeof skuSpecObj[group?.specGroupId] === 'string'
                            ? skuSpecObj[group?.specGroupId]
                            : JSON.stringify(skuSpecObj[group?.specGroupId]) || '{}',
                    );
                    if (groupObjP[param?.specParamId]) {
                        return param;
                    }
                });
            });
        });
        console.log({ commonGroups });
        return commonGroups;
    };

    // useEffect(() => {
    //     const getProductDataHandle = async () => {
    //         const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
    //         setProductDataA(productPageData);
    //     };
    //     getProductDataHandle();
    // }, []);
    useEffect(() => {
        const getProductSeriesData = async () => {
            const promiseAll = new Set();
            const proMsgAll: any[] = [];
            const productPageData = {
                productCatagory: null,
                productSeries: [] as any[],
                supportDataArr: [] as any[],
            };
            generalKeys?.map((item: GeneralKeyItemProps, _: number) => {
                console.log({ item });
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                if (Object.keys(productMsg)?.length > 0) {
                    proMsgAll.push(productMsg);
                    promiseAll.add(productDetailData({ handle: item.url }, locale || 'us'));
                }
            });

            Promise.all(promiseAll).then((resArr) => {
                resArr.map((resItem: any, resIndex) => {
                    if (resItem && resItem.code === '0') {
                        if (resIndex === 0) {
                            productPageData.productCatagory = resItem?.data?.productCatagoryResponseList;
                        }
                        productPageData.productSeries.push(resItem?.data?.spuResponse);
                    }
                });
                setProductPageData(productPageData);
            });
        };

        getProductSeriesData();
    }, []);

    useEffect(() => {
        console.log({ productPageData });
    }, [productPageData]);

    return (
        <>
            {/* <ProductNav activeTab={'Specs'} />
            {productDataA.spuId && (
                <ProductSpecs productCatagory={productDataA.productCatagory} productDetail={productDataA.productDetail} theme={productPageTheme} />
            )} */}
            <ProductNav activeTab={'Specs'} />

            {productPageData &&
                productPageData?.productSeries?.length > 0 &&
                productPageData?.productCatagory &&
                productPageData?.productCatagory.length > 0 && (
                    <ProductSpecs
                        productCatagory={productPageData?.productCatagory}
                        productDetail={productPageData?.productSeries[0]}
                        theme={productPageTheme}
                    />
                )}
            {/* <EfProductMultiSpec
                items={[...productPageData?.productSeries]}
                catagories={formatMultiSpecData(productPageData?.productCatagory, [...productPageData?.productSeries])}
                theme={productPageTheme}
            /> */}
        </>
    );
}
